<template>
  <QuestionBase :disabled-valid="false"
                :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="!!data">
    <InputBasic v-model="data"
                :args="args"
                :db="db"
                :noSave="noSave"
                :skipped="skipped"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'ExistingPropertyCapitalRaisingReason',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [
        Number,
        String
      ],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    newMortgage: {
      type: Number,
      required: false
    },
    existingMortgage: {
      type: Number,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    additional() {
      if (this.newMortgage - this.existingMortgage > 0) {
        return this.newMortgage - this.existingMortgage
      } else return null
    },
    question() {
      return {
        title: `${this.additional ? 'What are your plans for the additional £' + this.additional + '?' : 'What are your plans for the additional money?'}`,
        subTitle: null,
        tip: null,
      }
    },
  },
  data() {
    return {
      db: {
        saveLocation: 'mortgage_survey_save',
        saveField: 'existing_capital_raising_reason',
        objectId: this.objectId
      },
      args: {
        placeholder: 'e.g. Home improvements',
        label: null,
        type: 'text',
        skippable: false,
        required: true,
        inputClass: 'field-66',
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>